import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#003DA6",
      "fill-rule": "evenodd",
      d: "M0 0v11.7h16.2V0zm1.575.855 6.077 5.53c.178.161.449.164.63.005L14.579.855zm13.77.466L8.846 7.032c-.508.446-1.27.44-1.77-.015L.855 1.356v9.489h14.49z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }